<template>
  <div>
    <b-container>
      <FormulateForm v-model="formValues"
        class="form-wrapper"
        @submit="onSubmit"
        #default="{ isLoading }"
        name="requestForm"
        :invalid-message="invalidMessage"
      > 
        <h2 class="mt-5" v-if="!defaultValues">New Student Tranportation Request Form</h2>
        <h2 class="mt-5" v-if="defaultValues">Student Tranportation Change Form</h2>
        <b-row v-if="defaultValues">
          <b-col class="d-flex justify-content-center mt-3">
            <formulateInput
              label="Create a New Record Instead"
              type="button"
              @click="$router.go()"            
            />
          </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
              <student-info  id=studentInfo v-model=formValues :defaultValue="getDefaultStudentInfo()" /></b-col>

            <b-col md="12">
              <student-address label="Student Address" name="studentHome" v-model="formValues" :defaultValue="getDefaultStudentHome()"/></b-col>

            <b-col md="12">
              <contact-info v-model="formValues" :defaultValue="getDefaultContactInfo()"/></b-col>

            <b-col md="12">
              <trans-details v-model="formValues" :defaultValue="getDefaultTransDetails()"/></b-col>
          </b-row>
        <b-row>
            <b-col xs="12" class="text-center mt-3 mb-3">
              <formulateInput
                label="Check here if you have reviewed all the information provided above."
                name="reviewed"
                validation-name="Review"
                validation="^required"
                type="checkbox"
                @click="reviewClicked()"
              />
              <formulateInput
                label="Check here if you want to create a new form based on the information in this form."
                name="isSibling"
                type="checkbox"
              />
              <FormulateErrors />
              <FormulateInput
                class="mt-3"
                type="submit"
                :disabled="isLoading"
                :label="isLoading ? 'Loading...' : 'Submit this form'"
                validation-behavior="live"
                help="this is a help"
                />
            </b-col>
        </b-row>
      </FormulateForm>
      <b-modal ref="address-modal" hide-footer title="Choose the Correct Address" centered>
        <div class="d-block text-center">
          <h3>{{ currentAddressType }} Address</h3>
        </div>
        Possible invalid address:
        <b-button class="mt-1" variant="outline-danger" block @click="oldOnClick">{{ Object.values(currentAddress).join(', ') }}</b-button>
        Did you mean:
        <b-button class="mt-1" variant="outline-success" block @click="newOnClick">{{ getRecommendedAddress() }}</b-button>
      </b-modal>
      {{ quality }} <p></p>
      Endpoint Data: {{ formValues }} <p></p>
    </b-container>
  </div>
</template>

<script>
  import ContactInfo from '../components/ContactInfo.vue';
  import StudentAddress from '../components/StudentAddress.vue';
  import StudentInfo from '../components/StudentInfo.vue';
  import TransDetails from '../components/TransDetails.vue';
  import cloneDeep from 'clone-deep';
  import { postNewStudentForm, putChangeStudentForm } from '../services/api.js';
  import DropdownLists from '../components/DropdownLists.json';
  export default {
    components: { StudentAddress, ContactInfo, StudentInfo, TransDetails,},
    props: {
      defaultValues: {},
    },
    data() {
      return {
        formValues: {},
        quality: "",
        currentAddress: "",
        currentAddressType: "",
        recommendedAddress: {},
        weekdays: DropdownLists.weekdays,
        providedAddresses: [],
      }
    },
    methods: {
      getDefaultStudentInfo() {
        if (this.defaultValues) {
          let fields = ['firstName', 'middleName', 'lastName', 'DOB', 'gender', 'language', 'grade', 'studentId', 'program', 'marssCode']
          let ret = {}
          for (const field of fields) {
            ret[field] = this.defaultValues[field]
          }
          return [ret]
        }
      },
      getDefaultStudentHome() {
        return this.defaultValues ? [this.defaultValues.address] : ''
      },
      getDefaultContactInfo() {
        return this.defaultValues ? this.defaultValues.contacts : ''
      },
      getDefaultTransDetails() {
        let transDetails = {"inboundDays": [], "outboundDays": []}
        if (this.defaultValues) {
          transDetails['startDate'] = this.defaultValues.startDate
          transDetails['endDate'] = this.defaultValues.endDate
          transDetails['school'] = this.defaultValues.building
          for (const field of ["startDate", "endDate", "arrivalTime", "departureTime", "studentRelease"]) {
            transDetails[field] = this.defaultValues[field]
          }
          transDetails['startTime'] = this.defaultValues.programStartTime
          transDetails['schoolEndTime'] = this.defaultValues.programEndTime
          transDetails['newPickupAddress'] = this.defaultValues.pickupAddress
          transDetails['newDropoffAddress'] = this.defaultValues.dropoffAddress

          for (const [key, value] of Object.entries(this.weekdays)) {
            if (this.defaultValues.schedule[key] === 'I' || this.defaultValues.schedule[key] === 'B') {
              transDetails.inboundDays.push(value)
            }
            if (this.defaultValues.schedule[key] === 'O' || this.defaultValues.schedule[key] === 'B') {
              transDetails.outboundDays.push(value)
            }
          }

          transDetails['specialNeeds'] = []
          let specialNeeds = ["infoAide", "infoWheelchair", "infoSolo", "infoBoosterSeat", "infoSafetyVest", "infoSafetyBeltLockingCover", "infoCarSeat"]
          for (const need of specialNeeds) {
            if (this.defaultValues[need]) {
              transDetails['specialNeeds'].push(need)
              if (need == 'infoAide') {
                transDetails['aide'] = this.defaultValues.infoAide
                transDetails['aideOnetoOne'] = (transDetails.aide == "A1:1") ? true : false
              }
            }
          }
          return [transDetails]
        } else {
          return [transDetails]
        }
      },
      getRecommendedAddress () {
        return this.recommendedAddress[this.currentAddressType]?.Label
      },
      oldOnClick(){
        this.$refs['address-modal'].hide()
        this.formValues.reviewed = false
        let pair = this.providedAddresses.pop()
        if (pair)
          this.validate(pair.key, pair.address)
      },
      newOnClick(){
        this.setAddress(this.currentAddressType, this.currentAddress)
        this.formValues.reviewed = true

        this.$refs['address-modal'].hide()
        let pair = this.providedAddresses.pop()
        if (pair)
          this.validate(pair.key, pair.address)
      },
      recommendPopup(addressType, address) {
        this.currentAddressType = addressType
        this.currentAddress = address
        this.$refs['address-modal'].show()
        this.formValues.reviewed = false
      },
      invalidPopup(addressType, address, missing = '') {
          const h = this.$createElement
          // Using HTML string
          const title = h('div', { domProps: { innerHTML: `Please Confirm Your ${addressType}` } });
          const message =
            h('div', { class: ['foobar'] }, [
              h('p', { class: ['text-center'] }, [ 
                `We couldn't verify your ${addressType}. Please make sure all the fields in ${addressType} are filled correctly. Do you still want to use ${Object.values(address)}?`
              ]),
            ])
          this.$bvModal.msgBoxConfirm([message], {
            title: [title],
            size: 'lg',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          })
            .then(value => {
              if (!missing && value) {
                this.setAddress(addressType, address)
              } 
               // missing address and selected yes: still want to use this invalid adderess
               // missing address and selected no: want to put a new address
              if (missing && !value) {
                this.formValues.reviewed=false
                // this.scroll('logo')
              }
            })
            .catch(err => {
              console.log('err: ', err)
            })
      },
      async onSubmit () {        
        let clonedFormValues = cloneDeep(this.formValues);
        for (const [key, value] of Object.entries(clonedFormValues)){
          if (Array.isArray(value) &&  value.length === 1 && key != "contactInfo") {
            clonedFormValues[key] = value[0]
          }
          if (['isSibling', 'reviewed'].includes(key))
            delete clonedFormValues[key]
        }
        if (clonedFormValues.transDetails.aideOnetoOne) {
          delete clonedFormValues.transDetails.aideOnetoOne
        }
        for (const [key, value] of Object.entries(clonedFormValues.transDetails)){
          if (Array.isArray(value) &&  value.length === 1 && !["specialNeeds", "inboundDays", "outboundDays"].includes(key))
            clonedFormValues.transDetails[key] = value[0]
        }
        // clonedFormValues['internalId'] = this.defaultValues?.internalId
        try {
          let response = this.defaultValues ? await putChangeStudentForm(clonedFormValues, this.defaultValues.internalId) : await postNewStudentForm(clonedFormValues)
          console.log(response)
          if (response.status !== 201) {
            //  check for response.status
            throw new Error(response.statusText);
          }
          let body = await response.data; // or .json() or whatever
          console.log(body)
          // process body
          if (this.formValues.isSibling) {
            if (this.formValues.studentInfo) {
              this.scroll('logo')
              delete this.formValues['studentInfo'];
              this.formValues.reviewed = false;
              this.formValues.isSibling = false;
              alert('The previous form submitted, click here to fill out the next form')
            }
          } else{
            this.formValues = {};
            alert('All validation complete, form submitted.')
          }
        } catch (err) {
          alert('Form submission failed!')
          console.log(err)
        }
      },
      scroll(id) {
        const el = document.getElementsByClassName(id)[0];
        if(el){
          el.scrollIntoView({behavior: "smooth"});
        }
      },
      invalidMessage(fields) {
        const fieldNames = Object.keys(fields)
        const listOfNames = fieldNames.map(fieldName => fieldName.replace('_', ' '))
        return `Oops! There are some errors above. Invalid fields: ${listOfNames}`
      },
      reviewClicked() {
        let addresses = {
          "Drop-off": this.formValues?.transDetails[0]?.newDropoffAddress?.[0],
          "Pick-up": this.formValues?.transDetails[0]?.newPickupAddress?.[0],
          "School": this.formValues?.transDetails[0]?.schoolAddress?.[0],
          "Student": this.formValues?.studentHome?.[0],
        }
        for (const [key, address] of Object.entries(addresses)) {
          if (address) {
            this.providedAddresses.push({key, address})
          }
        }
        let pair = this.providedAddresses.pop()
        this.validate(pair.key, pair.address)
      },
      async validate(addressType, address = this.formValues.studentHome[0]) {
          let isFilled = !Object.values(address).includes("") && address.street && address.city && address.state && address.zip_code;
          try {
            let query = isFilled ? Object.values(address) : "."
            let result = await fetch(`https://geocoder.ls.hereapi.com/6.2/geocode.json?apiKey=LPlKDUjfKwdJJaqODRQzS1_pbdxLJcuTHcT-peJFDvE&searchtext=${query}`)
            if (result.status != 200){
              //  check for response.status
              throw new Error(result.statusText);
            }
            result = await result.json()
            if(result.Response.View.length > 0 && result.Response.View[0].Result.length > 0) {
                let data = result.Response.View[0].Result[0];
                this.quality = data.MatchQuality;
                this.recommendedAddress[addressType] = data.Location.Address ? data.Location.Address : null;

                for (const key of  ["Street", "City", "State", "HouseNumber", "PostalCode"]){
                  // if any of the key doesnt exist in the MatchQuality
                  if (this.formValues.reviewed && !Object.keys(data.MatchQuality).includes(key)){
                    this.invalidPopup(addressType, address, key);
                    break;
                  }
                  // if any of the key's MatchQuality less than 0.99 exist in the MatchQuality
                  else if (this.formValues.reviewed && data.MatchQuality[key] < 0.99) {
                    this.recommendPopup(addressType, address)
                    break;
                  } else {
                    let pair = this.providedAddresses.pop()
                    if (pair){
                      this.validate(pair.key, pair.address)
                    }
                  }
                }
              } else {
                if (isFilled) {
                  this.invalidPopup(addressType, address, true);
                }
                if (this.formValues.reviewed && !isFilled) {
                  alert('Please make sure all required fields are filled.')
                  this.formValues.reviewed = false
                }
              }
            return true
          } catch (error) {
            console.error(error);
          }
      },
      setAddress (addressType, address = this.formValues.studentHome[0]) {
        if (this.recommendedAddress[addressType].HouseNumber)
          address.street = this.recommendedAddress[addressType].HouseNumber +' '+ this.recommendedAddress[addressType].Street
        address.city = this.recommendedAddress[addressType].City
        address.state = this.recommendedAddress[addressType].State
        address.zip_code = this.recommendedAddress[addressType].PostalCode
      }
    },
    mounted() {
      this.scroll('bgimg2')
    },
  }
</script>